module.exports = __webpack_public_path__ + "static/media/BlogImg2.acf7dba5.png";